import React, { Component } from 'react'
import { path, not } from 'ramda'

import {SmallButton} from 'components/buttons'
import { Wrapper, ChooseFileWrapper, ChooseFileInput, ImagePreviewCard, ErrorMessage, FileName } from './components'

class Upload extends Component {
  state = {
    url: this.props.file,
    name: '',
    size: '',
    isFile: false
  }

  componentWillReceiveProps (nextProps) {
    this.convertToUrl(nextProps.file)
  }

  componentDidMount () {
    this.convertToUrl(this.props.file)
  }

  convertToUrl = file => {
    if (file) {
      if(typeof file !== 'string') {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          this.setState(() => ({
            url: reader.result,
            name: path(['name'], file),
            isFile: true
          }))
        }
      } else {
        this.setState(() => ({
          url: file,
          name: 'photo',
          isFile: true
        }))
      }
    }
  }

  onChangeFile = e => {
    const file = (e.target.files || e.dataTransfer.files)[0]

    if(path(['loadImage'], this.props)) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        this.setState(() => ({
          url: reader.result,
          name: file.name,
          size: file.size,
          isFile: true
        }))
      }
    } else {
      this.setState(() => ({
        name: file.name,
        size: file.size,
        isFile: true
      }))
    }

    if(path(['props', 'onChange'], this)) this.props.onChange(file, file.name, file.size)

  }

  removeFile = () => {
    this.setState(() => ({
      name: '',
      size: '',
      url: null,
      isFile: false
    }))
    if(path(['props', 'onChange'], this)) this.props.onChange(null)
  }

  renderInputButton = () => this.state.isFile // maybe name
    ? <SmallButton value = 'Видалити' onClick={this.removeFile}/>
    : <SmallButton value = {path(['props', 'label'], this) || 'Завантажити'} />

  renderFileInput = () => {
    if (this.state.isFile) return
    return (
      <ChooseFileInput
        type="file"
        accept={path(['props', 'accept'], this)} //".png, .jpg, .jpeg, .gif"
        onChange={this.onChangeFile}
      />
    )}

  renderImageCard = () => path(['props', 'loadImage'], this) &&
    <ImagePreviewCard backgroundImage={this.state.url || 'none'}>
      {this.state.isFile ? '' : (this.state.name || 'фото відсутнє')}
    </ImagePreviewCard>

  renderFileName = () => not(path(['props', 'loadImage'], this)) &&
    <FileName>
      {this.state.name}
    </FileName>

  renderErrorMessage = () => path(['props', 'error'], this) &&
    <ErrorMessage>
      Обов'язкове поле
    </ErrorMessage>

  render(){
    return (
      <Wrapper loadImage = {path(['props', 'loadImage'], this)}>
        {this.renderImageCard()}
        <ChooseFileWrapper>
          {this.renderFileInput()}
          {this.renderInputButton()}
        </ChooseFileWrapper>
        {this.renderFileName()}
        {this.renderErrorMessage()}
      </Wrapper>
    )}
}


export default Upload


// WEBPACK FOOTER //
// ./src/components/upload/index.js